import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { Button, Modal } from "react-bootstrap";
import { fetchStripeSessionSecret } from "../../controllers/orders";
import { stripeKey } from "../../controllers/config";
import { loadStripe } from "@stripe/stripe-js";

function OrderPaymentModal({ show, handleClose, onPayment, order }) {
  const stripePromise = loadStripe(stripeKey);
  const lineItems = order && order.line_items.map(l => {
    return {
        label: l.label,
        productType: l.product.productType,
        productId: l.product_id,
        productPrice: l.product_original_price,
        quantity: l.quantity
      }
  })
  const stripeOptions = {
    fetchClientSecret: fetchStripeSessionSecret(lineItems, null, null, null, null, order?.order_id),
    onComplete: onPayment,
  };
  return <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Pago de la orden: {order?.order_id}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={stripeOptions}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Cerrar
      </Button>
    </Modal.Footer>
  </Modal>;
}

export default OrderPaymentModal;
